import request from '@/utils/request'
const apiPath = '/course/courseScenarioAnswer'
const courseScenarioAnswerApi = {
  /**
   * 新增【情景练习回答记录】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  audit(data) {
    return request.post(apiPath + '/audit', data, { isFormData: 1 })
  },
  /**
   * 修改【情景练习回答记录】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【情景练习回答记录】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【情景练习回答记录】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【情景练习回答记录】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
}
export default courseScenarioAnswerApi
